export default __webpack_public_path__ + "static/media/product_dummy.292a171b.jpg";